import './applications-overview.scss';
import { findAll, onBlockRender, once } from '../../global/utils/acf-preview';

function initTabs( root: HTMLElement ): void {
	if ( ! once( root, 'AppTabs' ) ) {
		return;
	}
	const tabs = Array.from( root.querySelectorAll<HTMLButtonElement>( '.applications-overview__tab' ) );
	const panels = Array.from( root.querySelectorAll<HTMLElement>( '.applications-overview__panel' ) );
	if ( ! tabs.length ) {
		return;
	}

	const select = ( index: number, focus = false ): void => {
		tabs.forEach( ( tab, i ) => {
			const active = i === index;
			tab.classList.toggle( 'is-active', active );
			tab.setAttribute( 'aria-selected', active ? 'true' : 'false' );
			tab.tabIndex = active ? 0 : -1;
			if ( active && focus ) {
				tab.focus();
			}
		} );
		panels.forEach( ( panel, i ) => {
			const active = i === index;
			panel.classList.toggle( 'is-active', active );
			panel.toggleAttribute( 'hidden', ! active );
		} );
	};

	tabs.forEach( ( tab, i ) => {
		tab.addEventListener( 'click', () => select( i ) );
		tab.addEventListener( 'keydown', ( event: KeyboardEvent ) => {
			let next = -1;
			if ( event.key === 'ArrowRight' || event.key === 'ArrowDown' ) {
				next = ( i + 1 ) % tabs.length;
			} else if ( event.key === 'ArrowLeft' || event.key === 'ArrowUp' ) {
				next = ( i - 1 + tabs.length ) % tabs.length;
			} else if ( event.key === 'Home' ) {
				next = 0;
			} else if ( event.key === 'End' ) {
				next = tabs.length - 1;
			}
			if ( next !== -1 ) {
				event.preventDefault();
				select( next, true );
			}
		} );
	} );
}

onBlockRender( 'applications-overview', ( root ) => {
	findAll<HTMLElement>( root, '[data-applications-tabs]' ).forEach( initTabs );
} );
